import session from './session';

export default {
  login(username, password) {
    return session.post('/api/auth/token/login/', { username, password });
  },
  logout() {
    return session.post('/api/auth/token/logout/', {});
  },
  registration(username, password, email) {
    return session.post('/api/auth/users/', { username, password, email });
  },
  changeAccountPassword(new_password, old_password2) {
    return session.post('/api/auth/users/set_password/', { new_password, old_password2 });
  },
  resetPasswordEmail(email) {
    return session.post('/api/auth/users/reset_password/', { email });
  },
  resetPasswordConfirm(uid, token, new_password ) { // eslint-disable-line camelcase
    return session.post('/api/auth/users/reset_password_confirm/', { uid, token, new_password });
  },
  getCurrentUser() {
    return session.get('/api/auth/users/me/', );
  },
  updateAccountDetails(email) {
    return session.patch('/api/auth/users/', { email });
  },
  verifyAccountEmail(uid, token) {
    return session.post('/api/auth/users/activation/', { uid, token });
  },
};
